// extracted by mini-css-extract-plugin
module.exports = {"officeEditorialPage":"OfficeEditorialPage_officeEditorialPage__hVO8S","content":"OfficeEditorialPage_content__D8jPE"};